<template>
  <div class="py-3 bg-finger">
    <div class="container">
      <div class="mb-3"><img src="\img\logopriadi.png" class="img-fluid d-block" width="140" alt="" /></div>
      <p class="lead text-white fw-bold" style="font-size: 0.9em">
        <!-- {{ $t('sloganHome') }} <br /> -->
        {{ $t('sloganHomeSubtitle') }}
      </p>
    </div>
    <div class="container-fluid">
      <div class="d-flex align-items-center overflow-scroll" style="scrollbar-width: none; -ms-overflow-style: none;">
        <img v-for="i in 6" v-bind:key="i" v-bind:src="`/img/slide-home/${i}.png`" class="w-75 me-2" alt="" />
      </div>
    </div>
  </div>

  <div class="container mt-4 mb-5 pb-3">
    <ul class="nav nav-pills mb-3 gap-1" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active rounded-pill fw-bold"
          id="pills-home-tab"
          data-bs-toggle="pill"
          data-bs-target="#pills-home"
          type="button"
          role="tab"
          aria-controls="pills-home"
          aria-selected="true">
          {{ $t('testPackage') }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link rounded-pill fw-bold"
          id="pills-profile-tab"
          data-bs-toggle="pill"
          data-bs-target="#pills-profile"
          type="button"
          role="tab"
          aria-controls="pills-profile"
          aria-selected="false">
          {{ $t('promo') }}
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div class="col mb-3" v-for="(subcategory, index) in get_subcategory" v-bind:key="subcategory">
          <div class="card shadow package-card p-0" @click="openDetail(index)">
            <div class="card-body text">
              <span class="text-primary d-block fw-bold fs-5">{{ subcategory.name }}</span>
              <span class="d-block text-muted" style="font-size: 0.75em; font-weight: 500">
                {{ subcategory.grouping }}
              </span>
              <div class="d-flex justify-content-between align-items-end mt-4">
                <span class="fw-bold fs-6 d-block">
                  {{ 'Rp.' + Intl.NumberFormat('id').format(subcategory.price) + ',-' }} <br />
                  <span class="fw-normal" v-if="subcategory.is_consultation === '1'">+ {{ $t('freeConsult') }}</span>
                </span>
                <div class="text-primary fw-bold bg-primary text-white px-3 py-1 rounded-3 rounded" style="cursor: pointer">
                  {{ $t('selectPackage') }}
                </div>
                <!-- <img src="/img/choose_ribbon.png" class="position-absolute end-0 w-25" style="bottom: 10%" alt="" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="row row-cols-1 gap-2 mb-3" v-if="get_promo">
          <div class="col" v-for="(promo, index) in get_promo" v-bind:key="promo">
            <div class="card shadow package-card" @click="openDetail(index, 'yes')">
              <!-- <img src="/img/promo_ribbon.png" class="start-0" width="120" alt="" /> -->
              <div class="card-body text">
                <span class="text-primary d-block fw-bold fs-5">{{ promo.name }}</span>
                <span class="d-block text-muted" style="font-size: 0.75em; font-weight: 500">
                  {{ promo.grouping }}
                </span>
                <div class="d-flex justify-content-between align-items-end mt-3">
                  <div>
                    <span class="fw-bold me-1 d-block">
                      <s class="fw-bold text-danger d-block">{{ 'Rp.' + Intl.NumberFormat('id').format(promo.price_real) }}</s>
                      {{ 'Rp.' + Intl.NumberFormat('id').format(promo.price) }}
                    </span>
                    <span class="fw-normal" v-if="promo.is_consultation === '1'">+ {{ $t('freeConsult') }}</span>
                  </div>
                  <div class="text-primary fw-bold bg-primary text-white px-3 py-1 rounded-3 rounded" style="cursor: pointer">
                    {{ $t('selectPackage') }}
                  </div>
                  <!-- <img src="/img/choose_ribbon.png" class="position-absolute end-0 w-25" style="bottom: 10%" alt="" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow-lg mb-3" style="border-radius: 20px">
          <div class="card-body">
            <p class="h5">{{ $t('promo') }}</p>
            <p style="font-size: 10pt; text-align: justify">
              {{ $t('voucherCodeText') }}
            </p>
            
            <!-- Error message -->
            <div v-if="promoError" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{ promoError }}
              <button type="button" class="btn-close" @click="promoError = ''"></button>
            </div>
            
            <!-- Success message -->
            <div v-if="promoSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{ promoSuccess }}
              <button type="button" class="btn-close" @click="promoSuccess = ''"></button>
            </div>
            
            <form @submit.prevent="select_promo(referral_code)">
              <input
                type="text"
                v-model="referral_code"
                name=""
                class="form-control w-100 mx-auto"
                :placeholder="$t('voucherCodeHint')"
                id="" />
              <button type="submit" class="btn text-white d-block w-100 mt-2 fs-6" style="background-color: #30baca">
                {{ $t('submit') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <BottomNav />

  <!-- Modal for login options (shown when user is not authenticated) -->
  <div class="modal fade" :class="{ show: showLoginModal }" :style="{ display: showLoginModal ? 'block' : 'none' }" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <p class="text-muted mb-4">{{ $t('guessModalText') }}</p>
          <div class="d-grid gap-2">
            <button class="btn btn-primary" @click="handleSignIn">
              <i class="bi bi-box-arrow-in-right"></i> {{ $t('signin') }}
            </button>
            <button class="btn btn-outline-secondary" @click="handleGuestAccess">
              <i class="bi bi-person-check"></i> {{ $t('continueAsGuest') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" :class="{ show: showLoginModal }" :style="{ display: showLoginModal ? 'block' : 'none' }"></div>
</template>

<script>
// import Navigation from "../components/Navigation";
import BottomNav from '../components/BottomNav'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    BottomNav,
    // Navigation,
  },
  data() {
    return {
      selectedPills: false,
      referral_code: '',
      get_subcategory: [],
      get_promo: [],
      showLoginModal: false,
      promoError: '',
      promoSuccess: '',
    }
  },
  created() {
    this.select_subcategory()
  },
  methods: {
    select_subcategory() {
      let self = this
      axios
        .get('https://api.priadi.id/api/list_report', {
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          self.get_subcategory = response.data.list_report.sort((a, b) => a.price - b.price)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    select_promo(referral_code) {
      let self = this
      
      // Clear previous messages
      self.promoError = ''
      self.promoSuccess = ''
      
      // Check if referral code is empty
      if (!referral_code || referral_code.trim() === '') {
        self.promoError = self.$t('invalidReferralCode')
        return
      }
      
      axios
        .get('https://api.priadi.id/api/list_report', {
          params: { reff_code: referral_code },
          headers: { 'x-api-key': process.env.VUE_APP_PRIADI_API_KEY },
        })
        .then((response) => {
          const promoData = response.data.list_report.sort((a, b) => a.price - b.price)
          
          // Check if the referral code provides any discount
          // by comparing if prices have changed
          let hasDiscount = false
          
          if (promoData && promoData.length > 0) {
            // Compare the first item's price to see if there's a discount
            for (let i = 0; i < promoData.length; i++) {
              if (promoData[i].price < promoData[i].price_real) {
                hasDiscount = true
                break
              }
            }
          }
          
          if (!hasDiscount) {
            // Referral code is invalid - no discount applied
            self.promoError = self.$t('referralCodeError')
            self.get_promo = ''
            self.referral_code = ''
          } else {
            // Referral code is valid - show success message
            self.get_promo = promoData
            self.promoSuccess = self.$t('codeApplied')
            self.referral_code = ''
          }
        })
        .catch((error) => {
          console.log(error)
          self.promoError = self.$t('codeInvalid')
          self.get_promo = ''
          self.referral_code = ''
        })
    },
    openDetail(index, isPromo = 'no') {
      if (isPromo === 'no') {
        const item = this.get_subcategory[index]
        if (!item) return
        this.$store.dispatch('setPackage', item)
        this.$router.push({ name: 'Package Detail' })
      } else {
        const item = this.get_promo[index]
        if (!item) return
        item.voucher_code = this.referral_code
        this.$store.dispatch('setPackage', item)
        this.$router.push({ name: 'Package Detail' })
      }
    },
    closeLoginModal() {
      this.showLoginModal = false
    },
    handleSignIn() {
      this.closeLoginModal()
      this.$router.push('/auth')
    },
    handleRegister() {
      this.closeLoginModal()
      this.$router.push('/register')
    },
    handleGuestAccess() {
      this.closeLoginModal()
    },
  },
  mounted() {
    document.body.style.backgroundColor = '#EEEFFF'
    this.package = this.$store.getters.getPackage
    
    // Show login modal if user is not authenticated
    if (!this.$store.getters.isAuth) {
      this.showLoginModal = true
    }
  },
  unmounted() {
    document.body.style.backgroundColor = '#FFFFFF'
  },
}
</script>

<style scoped>
.bg-gold {
  background-color: #f39c12;
}

.bg-finger {
  background: #08a0f1 url('/img/fpimageup.png');
  background-size: cover;
}

.package-card {
  border-radius: 20px;
}

.padding-tab-content {
  padding-top: 1em;
}

.rounded-pill {
  font-size: 9pt;
}

@media only screen and (min-width: 320px) {
  .package-name {
    font-size: 8pt;
  }

  .package-target {
    font-size: 6pt;
  }

  .package-consultation {
    font-size: 6pt;
  }

  .package-price {
    font-size: 7pt;
  }

  .package-btn {
    font-size: 9pt;
  }
}

@media only screen and (min-width: 375px) {
  .rounded-pill {
    font-size: 11pt;
  }

  .package-name {
    font-size: 10pt;
  }

  .package-target {
    font-size: 7pt;
  }

  .package-consultation {
    font-size: 7pt;
  }

  .package-price {
    font-size: 10pt;
  }

  .package-btn {
    font-size: 10pt;
  }
}

@media only screen and (min-width: 425px) {
  .package-name {
    font-size: 11pt;
  }

  .package-target {
    font-size: 7pt;
  }

  .package-consultation {
    font-size: 7pt;
  }

  .package-price {
    font-size: 10pt;
  }

  .package-btn {
    font-size: 10pt;
  }
}

@media only screen and (min-width: 768px) {
  .package-name {
    font-size: 18pt;
  }

  .package-target {
    font-size: 12pt;
  }

  .package-consultation {
    font-size: 12pt;
  }

  .package-price {
    font-size: 12pt;
  }

  .package-btn {
    font-size: 14pt;
  }
}
</style>
